import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { Phone } from 'lucide-react'

export default function Footer() {
  return (
    <footer className="bg-white dark:bg-zinc-900 border-t border-gray-200 dark:border-zinc-800 mt-auto transition-colors lg:ml-64">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-6 sm:py-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            {/* Logo i nazwa firmy */}
            <div className="flex items-center">
              <Image
                src="/logo.png?v=3"
                alt="STALFES Logo"
                width={56}
                height={28}
                className="object-contain mr-3"
              />
              <div>
                <h3 className="text-base sm:text-lg font-semibold text-gray-900 dark:text-zinc-100">Stalfes System</h3>
                <p className="text-xs sm:text-sm text-gray-600 dark:text-zinc-400">Zaawansowany system zarządzania</p>
              </div>
            </div>

            {/* Linki nawigacyjne */}
            <div className="flex flex-col sm:flex-row sm:space-x-8 space-y-2 sm:space-y-0 mb-4 md:mb-0">
              {/* <Link
                href="/privacy"
                className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200"
              >
                Polityka prywatności
              </Link>
              <Link
                href="/terms"
                className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200"
              >
                Regulamin
              </Link>
              <Link
                href="/contact"
                className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200"
              >
                Kontakt
              </Link>
              <Link
                href="/help"
                className="text-sm text-gray-600 hover:text-blue-600 transition-colors duration-200"
              >
                Pomoc
              </Link> */}
            </div>

            {/* Kontakt */}
            <div className="text-left md:text-right">
              <p className="text-xs sm:text-sm text-gray-600 dark:text-zinc-400">
                <span className="block mb-1">Wsparcie techniczne:</span>
                <a
                  href="tel:+48667882257"
                  className="inline-flex items-center text-[#0084ff] hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 font-medium"
                >
                  <Phone className="inline-block mr-2" size={16} />
                  Kuba: 667-882-257
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-200 dark:border-zinc-800 py-3 sm:py-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
            <p className="text-xs sm:text-sm text-gray-500 dark:text-zinc-500">
              &copy; {new Date().getFullYear()} Stalfes Wszelkie prawa zastrzeżone.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}